import React from "react";
import ReactGA from "react-ga";

export default class PaymentSuccessful extends React.Component {
  componentWillMount() {
    const { history } = this.props;
    history.push("/download");
    if (this.props.location.query.status === "done") {
      ReactGA.event({
        category: "Purchases",
        action: "Purchased Ghast Premium",
        value: 10
      });
    }
  }

  render() {
    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/pages/paymentSuccessful/index.js
 **/